import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { Breadcrumb, useLocalization, useStore } from '@ui-framework/index';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import {
  IconLibrary,
  Layout,
  StackablePageButtons,
  SJForm,
} from '@product-framework/index';
import formSchema from '../../schemas/preregister.json';

function ServiceJobPreRegister() {
  const { formatMessage } = useLocalization();
  const navigate = useNavigate();
  const store = useStore();

  const breadCrumb = [
    {
      name: formatMessage({
        id: 'DASHBOARD',
        defaultMessage: 'Dashboard',
      }),
      icon: IconLibrary.Dashboard,
      onClick: () => {
        navigate('/dashboard');
      },
    },
    {
      name: formatMessage({
        id: 'JOBS',
        defaultMessage: 'Jobs',
      }),
      icon: IconLibrary.ServiceJobs,
      onClick: () => {
        navigate('/servicejobs');
      },
    },
    {
      name: formatMessage({
        id: 'CREATE_JOB',
        defaultMessage: 'Create Job',
      }),
      icon: IconLibrary.ServiceJob,
      onClick: undefined,
    },
  ];

  const stackablePageButtons = [
    {
      label: formatMessage({
        id: 'LIST_JOBS',
        defaultMessage: 'List Jobs',
      }),
      Icon: IconLibrary.ServiceJobs,
      variant: 'outlined',
      onClick: () => {
        store.domain.list.reset('ServiceJobList');
        navigate('/servicejobs');
      },
    },
  ];

  return (
    <Layout>
      <Grid2 xs={12} container>
        <Grid2 xs={12} md={6}>
          <Breadcrumb items={breadCrumb} />
        </Grid2>
        <Grid2 xs={12} md={6}>
          <StackablePageButtons buttons={stackablePageButtons} />
        </Grid2>
      </Grid2>
      <Grid2 xs={12}>
        <SJForm action="CREATE" formSchema={formSchema} />
      </Grid2>
    </Layout>
  );
}

export default observer(ServiceJobPreRegister);
